import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Account {
  id: string;
  name: string;
  code: string;
  type: string;
}

export default function Accounts() {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/api/accounts')
      .then((res) => {
        if (!cancelled) setAccounts(res.data ?? []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Failed to load accounts');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return <div style={styles.heading}>Accounts</div>;
  }

  return (
    <div>
      <h1 style={styles.heading}>Accounts</h1>

      {error && (
        <div style={{ ...styles.card, padding: 20, marginBottom: 16 }}>
          <p style={{ color: '#b91c1c', fontSize: 14, margin: 0 }}>{error}</p>
        </div>
      )}

      {!error && accounts.length === 0 && (
        <div style={{ ...styles.card, padding: 20, marginBottom: 16 }}>
          <p style={{ color: '#6b7280', fontSize: 14, margin: 0 }}>
            No accounts yet. Create accounts to build your chart of accounts.
          </p>
        </div>
      )}

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Code</th>
            <th style={styles.th}>Name</th>
            <th style={styles.th}>Type</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((a) => (
            <tr key={a.id}>
              <td style={styles.td}>{a.code}</td>
              <td style={styles.td}>{a.name}</td>
              <td style={styles.td}>{a.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  card: { background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#6b7280' },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
};
